import React, { useRef, useState } from "react";
import { NodeViewWrapper } from "@tiptap/react";
import {
	Button,
	IconComponent,
	Input,
	Popover,
	PopoverContent,
	PopoverTrigger,
	Tabs,
	TabsContent,
	TabsList,
	TabsTrigger
} from "../../../components";
import { useLocale } from "../../../locales";
import { createImageUpload } from "../../../plugins/image-upload";
import FileUpload from "../../../../Molecule/Inputs/FileUpload/FileUpload";
import { KonfhubButton } from "../../../../Atom/Buttons";

function ImageUploader(props) {
	const { t } = useLocale();
	const [link, setLink] = useState("");
	const [file, setFile] = useState(null);

	const handleFileUpload = selectedFile => {
		setFile(selectedFile);
		if (!props.editor || props.editor.isDestroyed || !selectedFile) {
			return;
		}

		const uploadOptions = props.editor.extensionManager.extensions.find(
			extension => extension.name === "imageUpload"
		)?.options;

		const uploadFn = createImageUpload({
			validateFn: () => {
				return true;
			},
			onUpload: uploadOptions.upload
		});
		uploadFn([selectedFile], props.editor.view, props.getPos());
	};

	function handleLink(link) {
		props.editor
			.chain()
			.setImage({ src: link })
			.deleteRange({ from: props.getPos(), to: props.getPos() })
			.focus()
			.run();
	}

	function handleDelete(e) {
		e?.preventDefault();
		props.deleteNode();
	}

	return (
		<NodeViewWrapper className="richtext-p-0 richtext-m-0" data-drag-handle>
			<Popover defaultOpen>
				<PopoverTrigger asChild>
					<div className="richtext-flex richtext-items-center richtext-w-full richtext-p-3 richtext-my-3 richtext-transition-all !richtext-border  richtext-cursor-pointer hover:richtext-bg-accent richtext-border-border richtext-text-muted-foreground">
						<div className="richtext-flex richtext-items-center richtext-justify-between richtext-w-full">
							<div className="richtext-flex richtext-items-center richtext-justify-center richtext-gap-3">
								<IconComponent
									name="ImageUp"
									className="richtext-w-6 richtext-h-6"
								/>
								<span className="richtext-text-sm">
									{t("editor.image.dialog.title")}
								</span>
							</div>
							<IconComponent
								name="Trash2"
								className="hover:richtext-text-foreground"
								onClick={handleDelete}
							/>
						</div>
					</div>
				</PopoverTrigger>
				<PopoverContent
					className="richtext-w-full"
					onOpenAutoFocus={e => e.preventDefault()}
				>
					<Tabs
						defaultValue="upload"
						className="richtext-w-[400px]"
						activationMode="manual"
					>
						<TabsList>
							<TabsTrigger value="upload">Upload</TabsTrigger>
							<TabsTrigger value="link">Link</TabsTrigger>
						</TabsList>
						<TabsContent value="upload">
							<FileUpload
								accept="image/*"
								onFileSelect={handleFileUpload}
								noCrop
								moduleNumber={4}
								onChange={(downloadUrl, imageObj) => {
									setLink(downloadUrl);
									handleLink(downloadUrl);
								}}
							/>
						</TabsContent>
						<TabsContent value="link">
							<div className="richtext-flex richtext-items-center richtext-gap-2">
								<Input
									type="url"
									autoFocus={true}
									required
									placeholder="Link"
									onChange={inputValue => {
										console.log(inputValue);
										setLink(inputValue?.target?.value);
									}}
								/>
								<KonfhubButton onClick={() => handleLink(link)} className='richtext-apply-button'>
									Apply
								</KonfhubButton>
							</div>
						</TabsContent>
					</Tabs>
				</PopoverContent>
			</Popover>
		</NodeViewWrapper>
	);
}

export default ImageUploader;
